module.exports = __webpack_public_path__ + "static/media/70s.4d27980e.png";